import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import RecipeRatings from './RecipeRatings';
import { isValid, decodeTags } from '../../../../utils';
import './recipe-header.scss';

const RecipeHeader = ({
  id, 
  slug, 
  data, 
  isMobile, 
  average, 
  numOfRatings,
  hideRecipeRatings
}) => {
  if (!isValid(data)) { return null; }
  let encodedTeaser = decodeTags(data.recipeTeaser);

  const ratingsArray = [0, 0, 0, 0, 0];
  const renderedAvgRatings = ratingsArray.map((rating, i) => {
      const labelClass = i < average ? "rating-label checked" : "rating-label unchecked"; 
      return (
        <label className={labelClass} />
      )
  });

  return (
    <div className="recipe-header">
      {!hideRecipeRatings && (
        <div className="rating-wrapper avg-rating-wrapper">
          <div className="rating-text">Average ({numOfRatings})</div>
          <div className="avg-rating-container">
            {renderedAvgRatings}
          </div>
        </div>
      )}
      <div className="recipe-teaser" dangerouslySetInnerHTML={ { __html: encodedTeaser } } />
    </div>
  );
}

export default RecipeHeader;